module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "data-widget": "tree"
    }
  }, [(this.key != 'reportManager' && this.key != 'monitoringManager') ? _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("Waste Transactions")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/primarytrip",
      "active-class": "active"
    }
  }, [_c('a', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32.309",
      "height": "34",
      "viewBox": "0 0 32.309 34"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_17332",
      "data-name": "Group 17332",
      "transform": "translate(-31 -1507)"
    }
  }, [_c('g', {
    attrs: {
      "id": "room_black_24dp_1_",
      "data-name": "room_black_24dp (1)",
      "transform": "translate(31 1507)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_1",
      "data-name": "Path 1",
      "d": "M0,0H32.309V32.309H0Z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Path_2",
      "data-name": "Path 2",
      "d": "M14.423,2A9.416,9.416,0,0,0,5,11.423c0,7.068,9.423,17.5,9.423,17.5s9.423-10.433,9.423-17.5A9.416,9.416,0,0,0,14.423,2Zm0,12.789a3.365,3.365,0,1,1,3.365-3.365A3.367,3.367,0,0,1,14.423,14.789Z",
      "transform": "translate(1.731 1.692)",
      "fill": "#000"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle_6342",
      "data-name": "Rectangle 6342",
      "width": "19",
      "height": "2",
      "rx": "1",
      "transform": "translate(38 1539)",
      "fill": "#000"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Primary Trips ")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/surveys",
      "active-class": "active"
    }
  }, [_c('a', [_c('svg', {
    attrs: {
      "id": "assignment_black_24dp_1_",
      "data-name": "assignment_black_24dp (1)",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "29.21",
      "height": "29.21",
      "viewBox": "0 0 29.21 29.21"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_23891",
      "data-name": "Path 23891",
      "d": "M0,0H29.21V29.21H0Z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Path_23892",
      "data-name": "Path 23892",
      "d": "M22.473,3.434H17.386a3.637,3.637,0,0,0-6.864,0H5.434A2.441,2.441,0,0,0,3,5.868V22.907a2.441,2.441,0,0,0,2.434,2.434H22.473a2.441,2.441,0,0,0,2.434-2.434V5.868A2.441,2.441,0,0,0,22.473,3.434Zm-8.52,0a1.217,1.217,0,1,1-1.217,1.217A1.221,1.221,0,0,1,13.954,3.434Zm2.434,17.039H7.868V18.039h8.52ZM20.039,15.6H7.868V13.171H20.039Zm0-4.868H7.868V8.3H20.039Z",
      "transform": "translate(0.651 0.217)",
      "fill": "#000"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Surveys")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/houses",
      "active-class": "active"
    }
  }, [_c('a', [_c('svg', {
    attrs: {
      "fill": "#000000",
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "800px",
      "height": "800px",
      "viewBox": "0 0 495.398 495.398",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('path', {
    attrs: {
      "d": "M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391\n\t\t\t\tv29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158\n\t\t\t\tc11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747\n\t\t\t\tc5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401\n\t\t\t\tc0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79\n\t\t\t\tc0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z"
    }
  })])])])]), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Houses")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("Monitoring")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/route-tracking",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    staticStyle: {
      "width": "17px",
      "margin-right": "3px"
    },
    attrs: {
      "src": "/static/img/monitoring_vehilcle.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Route Tracking")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/monitoring",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    staticStyle: {
      "width": "17px",
      "margin-right": "3px"
    },
    attrs: {
      "src": "/static/img/monitoring_survey.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Surveyor Tracking")])])])], 1), _vm._v(" "), (_vm.key != 'monitoringManager') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Reports")]) : _vm._e(), _vm._v(" "), (_vm.key != 'monitoringManager') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/line_collection_reports",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    staticStyle: {
      "width": "16px",
      "margin-right": "3px"
    },
    attrs: {
      "src": "/static/img/line-reports.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Line Collection")])])]) : _vm._e(), _vm._v(" "), (_vm.key != 'monitoringManager') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/city_collection_reports",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    staticStyle: {
      "width": "16px",
      "margin-right": "3px"
    },
    attrs: {
      "src": "/static/img/city_collection.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("City Collection")])])]) : _vm._e(), _vm._v(" "), (_vm.key != 'monitoringManager') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/daily_city_collection_reports",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    staticStyle: {
      "width": "16px",
      "margin-right": "3px"
    },
    attrs: {
      "src": "/static/img/daily-report.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Daily City Collection")])])]) : _vm._e(), _vm._v(" "), (_vm.key != 'monitoringManager') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/monthly_city_collection_reports",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    staticStyle: {
      "width": "16px",
      "margin-right": "3px"
    },
    attrs: {
      "src": "/static/img/monthlyReport.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Monthly City Collection")])])]) : _vm._e(), _vm._v(" "), (_vm.key != 'monitoringManager') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/ward-reports",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    staticStyle: {
      "width": "16px",
      "margin-right": "3px"
    },
    attrs: {
      "src": "/static/img/ward_collection_icon.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Ward Collection")])])]) : _vm._e(), _vm._v(" "), (_vm.key != 'monitoringManager') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/trip-reports",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    staticStyle: {
      "width": "16px",
      "margin-right": "3px"
    },
    attrs: {
      "src": "/static/img/car-report-icon.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Vehicle Trip")])])]) : _vm._e(), _vm._v(" "), (
    this.key != 'superVisor' &&
    this.key != 'reportManager' &&
    _vm.key != 'monitoringManager'
  ) ? _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("Master Data")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/city",
      "active-class": "active"
    }
  }, [(this.checkRole == 'Super Admin') ? _c('a', [_c('svg', {
    attrs: {
      "id": "city-location",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32.533",
      "height": "32.533",
      "viewBox": "0 0 32.533 32.533"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_23906",
      "data-name": "Path 23906",
      "d": "M0,0H32.533V32.533H0Z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Path_23907",
      "data-name": "Path 23907",
      "d": "M19.266,14.051V7.043a2.665,2.665,0,0,0-.8-1.911L16.149,2.814a1.35,1.35,0,0,0-1.911,0l-2.3,2.3a2.719,2.719,0,0,0-.8,1.925V8.629H5.711A2.719,2.719,0,0,0,3,11.34V24.9a2.719,2.719,0,0,0,2.711,2.711H24.689A2.719,2.719,0,0,0,27.4,24.9V16.762a2.719,2.719,0,0,0-2.711-2.711ZM8.422,24.9H5.711V22.185H8.422Zm0-5.422H5.711V16.762H8.422Zm0-5.422H5.711V11.34H8.422ZM16.555,24.9H13.844V22.185h2.711Zm0-5.422H13.844V16.762h2.711Zm0-5.422H13.844V11.34h2.711Zm0-5.422H13.844V5.918h2.711ZM24.689,24.9H21.977V22.185h2.711Zm0-5.422H21.977V16.762h2.711Z",
      "transform": "translate(1.067 -0.417)",
      "fill": "#000"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("City")])]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: (['user', 'createUser']),
      expression: "['user', 'createUser']",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/users",
      "active-class": "active"
    }
  }, [(this.checkRole == 'Super Admin') ? _c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("User")])]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/helperAndDriver",
      "active-class": "active"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Staff")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/wasteCollectionArea",
      "active-class": "active"
    }
  }, [_c('a', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "25",
      "height": "27.293",
      "viewBox": "0 0 25 27.293"
    }
  }, [_c('g', {
    attrs: {
      "id": "Map",
      "transform": "translate(-48.902 -29.908)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_23908",
      "data-name": "Path 23908",
      "d": "M349.568,175.881a7.278,7.278,0,0,1-.4.686l-3.43,4.8a3.1,3.1,0,0,1-2.52,1.3,3.063,3.063,0,0,1-.9-.149v9.931l5.961,1.873a1.019,1.019,0,0,0,.3.044,1.032,1.032,0,0,0,1.032-1.032v-17.2A1.019,1.019,0,0,0,349.568,175.881Z",
      "transform": "translate(-275.707 -137.163)",
      "fill": "#000"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Path_23909",
      "data-name": "Path 23909",
      "d": "M206.234,147.678l-2.168.6v19.342l6.28-1.729V154.251l-2.989-4.185A7.333,7.333,0,0,1,206.234,147.678Z",
      "transform": "translate(-145.798 -110.662)",
      "fill": "#000"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Path_23910",
      "data-name": "Path 23910",
      "d": "M49.318,125.1a1.031,1.031,0,0,0-.416.828v17.2a1.032,1.032,0,0,0,.735.988l6.566,2.062V126.819l-5.972-1.876A1.03,1.03,0,0,0,49.318,125.1Z",
      "transform": "translate(0 -89.258)",
      "fill": "#000"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Path_23911",
      "data-name": "Path 23911",
      "d": "M274.633,43.007a1.032,1.032,0,0,0,1.68,0l3.43-4.8a5.247,5.247,0,1,0-8.54,0Zm.84-9.572a1.72,1.72,0,1,1-1.72,1.72,1.72,1.72,0,0,1,1.72-1.72Z",
      "transform": "translate(-207.964 0)",
      "fill": "#000"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Zone")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/vehicles",
      "active-class": "active"
    }
  }, [_c('a', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "25.505",
      "height": "17.231",
      "viewBox": "0 0 25.505 17.231"
    }
  }, [_c('g', {
    attrs: {
      "id": "garbage-truck",
      "transform": "translate(-0.04 -83.077)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_23868",
      "data-name": "Path 23868",
      "d": "M30.061,261.707v2.221A1.062,1.062,0,0,1,29,264.991H11.764a1.062,1.062,0,0,1-1.063-1.063V260.2l.428-1.336h5.494v1.78a1.064,1.064,0,0,0,1.063,1.063Z",
      "transform": "translate(-10.13 -167.029)",
      "fill": "#000"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Path_23869",
      "data-name": "Path 23869",
      "d": "M395.544,150.82v3.487a1.063,1.063,0,0,1-1.063,1.063h-1.506a1.063,1.063,0,0,1-.876-.461L390,151.85v-7h2.666a1.063,1.063,0,0,1,1,.694l1.816,4.913A1.063,1.063,0,0,1,395.544,150.82Z",
      "transform": "translate(-370.53 -58.691)",
      "fill": "#000"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Path_23870",
      "data-name": "Path 23870",
      "d": "M180.822,104.789H168.4V94.8a1.063,1.063,0,0,1,1.063-1.063h9.584a1.063,1.063,0,0,1,1.039.837l1.9,8.761A1.2,1.2,0,0,1,180.822,104.789Z",
      "transform": "translate(-159.976 -10.134)",
      "fill": "#000"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Ellipse_1883",
      "data-name": "Ellipse 1883",
      "cx": "1.815",
      "cy": "1.815",
      "r": "1.815",
      "transform": "translate(2.862 96.145)",
      "fill": "#000"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Ellipse_1884",
      "data-name": "Ellipse 1884",
      "cx": "1.815",
      "cy": "1.815",
      "r": "1.815",
      "transform": "translate(13.197 96.145)",
      "fill": "#000"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Path_23871",
      "data-name": "Path 23871",
      "d": "M25.446,91.577,23.63,86.664a1.6,1.6,0,0,0-1.5-1.041H20.913l-.28-1.29a1.6,1.6,0,0,0-1.558-1.256H9.491A1.6,1.6,0,0,0,7.9,84.671v9.474H7.556a.532.532,0,0,1-.531-.531V87.56A1.6,1.6,0,0,0,5.43,85.966H3.486a1.589,1.589,0,0,0-1.518,1.108L.065,93.01a.533.533,0,0,0-.025.162V96.9a1.6,1.6,0,0,0,1.594,1.594h.759a2.344,2.344,0,0,0,4.568,0h5.767a2.344,2.344,0,0,0,4.568,0h1.572A1.6,1.6,0,0,0,20.463,96.9V95.546l.668.973a1.594,1.594,0,0,0,1.314.691h1.506a1.6,1.6,0,0,0,1.594-1.594V92.13A1.593,1.593,0,0,0,25.446,91.577ZM8.96,84.671a.532.532,0,0,1,.531-.531h9.584a.535.535,0,0,1,.519.419l1.9,8.761a.664.664,0,0,1-.649.8H8.96V84.671ZM3.486,87.028H5.43a.532.532,0,0,1,.531.531V91.3H1.728L2.98,87.4A.529.529,0,0,1,3.486,87.028ZM4.677,99.245a1.284,1.284,0,1,1,1.284-1.284A1.286,1.286,0,0,1,4.677,99.245Zm10.335,0A1.284,1.284,0,1,1,16.3,97.961,1.286,1.286,0,0,1,15.013,99.245ZM19.4,96.9a.532.532,0,0,1-.531.531H17.3a2.344,2.344,0,0,0-4.568,0H6.961a2.344,2.344,0,0,0-4.568,0H1.634A.532.532,0,0,1,1.1,96.9V93.255l.284-.888H5.961v1.246a1.6,1.6,0,0,0,1.594,1.594H19.4V96.9Zm5.082-1.282a.532.532,0,0,1-.531.531H22.445a.531.531,0,0,1-.438-.23l-.573-.834a1.726,1.726,0,0,0,1.1-1.989l-1.39-6.408h.991a.534.534,0,0,1,.5.347c1.895,5.158,1.849,4.922,1.849,5.1Z",
      "transform": "translate(0 0)",
      "fill": "#000"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Path_23872",
      "data-name": "Path 23872",
      "d": "M223.616,152.124a.531.531,0,0,0-1.034.244l.991,4.207a.531.531,0,1,0,1.034-.244Zm-2.872,0a.531.531,0,0,0-1.034.244l.991,4.207a.531.531,0,0,0,1.034-.244Zm-2.872,0a.531.531,0,0,0-1.034.244l.991,4.207a.531.531,0,0,0,1.034-.244Z",
      "transform": "translate(-205.983 -65.217)",
      "fill": "#000"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Vehicle")])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-84891178", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84891178"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/main/SidebarMenu.vue
// module id = 2362
// module chunks = 0